// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
const _import_ = file => () => import('@/views/' + file + '.vue');

// 启用路由
Vue.use(Router);

// 定义路由
export default new Router({
	routes: [{
		path: '*',
		hidden: true,
		meta: {
			requireAuth: false
		},
		redirect: '/error'
	}, {
		path: '/',
		name: 'index',
		component: _import_('index'),
		meta: {
			title: '首页',
			requireAuth: false
		}
	}, {
		path: '/login',
		name: 'login',
		component: _import_('login'),
		meta: {
			title: '合作商登录',
			requireAuth: false
		}
	}, {
		path: '/error',
		name: 'error',
		component: _import_('error'),
		meta: {
			title: '请求页面未找到',
			requireAuth: false
		}
	}, {
		path: '/platform',
		name: 'platform',
		component: _import_('platform'),
		redirect: '/error',
		meta: {
			title: '管理中心',
			requireAuth: false
		},
		children: [{
				path: '/console',
				name: 'console',
				component: _import_('console/index'),
				meta: {
					title: '控制台',
					active: 'console',
					requireAuth: true
				},
				children: [{
					path: '/console/cost',
					name: 'console_cost',
					component: _import_('console/cost'),
					meta: {
						title: '费用明细 - 控制台',
						active: 'console',
						requireAuth: true
					}
				}]
			}, {
				path: '/order',
				name: 'order',
				component: _import_('order/index'),
				children: [{
					path: '/order/dispatch',
					name: 'order_dispatch',
					component: _import_('order/dispatch'),
					meta: {
						title: '订单调度 - 订单管理',
						active: 'order',
						requireAuth: true
					}
				}, {
					path: '/order/list/all',
					name: 'order_list_all',
					component: _import_('order/list'),
					meta: {
						active: 'order',
						requireAuth: true
					}
				}, {
					path: '/order/list/arrive',
					name: 'order_list_arrive',
					component: _import_('order/list'),
					meta: {
						active: 'order',
						requireAuth: true
					}
				}, {
					path: '/order/list/service',
					name: 'order_list_service',
					component: _import_('order/list'),
					meta: {
						active: 'order',
						requireAuth: true
					}
				}, {
					path: '/order/list/pay',
					name: 'order_list_pay',
					component: _import_('order/list'),
					meta: {
						active: 'order',
						requireAuth: true
					}
				}, {
					path: '/order/list/complete',
					name: 'order_list_complete',
					component: _import_('order/list'),
					meta: {
						active: 'order',
						requireAuth: true
					}
				}, {
					path: '/order/list/cancel',
					name: 'order_list_cancel',
					component: _import_('order/list'),
					meta: {
						active: 'order',
						requireAuth: true
					}
				}, {
					path: '/order/comment',
					name: 'order_comment',
					component: _import_('order/comment'),
					meta: {
						title: '订单评价',
						active: 'order',
						requireAuth: true
					}
				}, {
					path: '/order/pay',
					name: 'order_pay',
					component: _import_('order/pay'),
					meta: {
						title: '支付记录',
						active: 'order',
						requireAuth: true
					}
				}]
			}, {
				path: '/driver',
				name: 'driver',
				component: _import_('driver/index'),
				meta: {
					title: '司机管理',
					active: 'driver',
					requireAuth: true
				}
			}, {
				path: '/user',
				name: 'user',
				component: _import_('user/index'),
				meta: {
					title: '用户管理',
					active: 'user',
					requireAuth: true
				}
			}, {
				path: '/marketing',
				name: 'marketing',
				component: _import_('marketing/index'),
				children: [{
					path: '/marketing/coupon',
					name: 'marketing_coupon',
					component: _import_('marketing/coupon'),
					meta: {
						title: '优惠券 - 营销管理',
						active: 'marketing',
						requireAuth: true
					}
				}, {
					path: '/marketing/store',
					name: 'marketing_store',
					component: _import_('marketing/store'),
					meta: {
						title: '合作门店 - 营销管理',
						active: 'marketing',
						requireAuth: true
					}
				}, {
					path: '/marketing/card',
					name: 'marketing_card',
					component: _import_('marketing/card'),
					meta: {
						title: '优惠名片 - 营销管理',
						active: 'marketing',
						requireAuth: true
					}
				}]
			}, {
				path: '/total',
				name: 'total',
				component: _import_('total/index'),
				meta: {
					title: '数据统计',
					active: 'total',
					requireAuth: true
				},
				children: [{
					path: '/total/survey',
					name: 'total_survey',
					component: _import_('total/survey'),
					meta: {
						title: '概况 - 数据统计',
						active: 'total',
						requireAuth: true
					}
				}, {
					path: '/total/order',
					name: 'total_order',
					component: _import_('total/order'),
					meta: {
						title: '订单统计 - 数据统计',
						active: 'total',
						requireAuth: true
					}
				}, {
					path: '/total/driver',
					name: 'total_driver',
					component: _import_('total/driver'),
					meta: {
						title: '司机统计 - 数据统计',
						active: 'total',
						requireAuth: true
					}
				}]
			}, {
				path: '/operate',
				name: 'operate',
				component: _import_('operate/index'),
				children: [{
					path: '/operate/config',
					name: 'operate_config',
					component: _import_('operate/config'),
					meta: {
						title: '基本设置 - 运营管理',
						active: 'operate',
						requireAuth: true
					}
				}, {
					path: '/operate/charging',
					name: 'operate_charging',
					component: _import_('operate/charging'),
					meta: {
						title: '计费设置 - 运营管理',
						active: 'operate',
						requireAuth: true
					}
				}, {
					path: '/operate/area',
					name: 'operate_area',
					component: _import_('operate/area'),
					meta: {
						title: '返程设置 - 运营管理',
						active: 'operate',
						requireAuth: true
					}
				}, {
					path: '/operate/admin',
					name: 'operate_admin',
					component: _import_('operate/admin'),
					meta: {
						title: '管理员 - 运营管理',
						active: 'operate',
						requireAuth: true
					}
				}]
			}
			// , {
			// 	path: '/operate',
			// 	name: 'operate',
			// 	component: _import_('operate/index'),
			// 	meta: {
			// 		title: '运营管理',
			// 		active: 'operate',
			// 		requireAuth: true
			// 	},
			// 	children: [{
			// 		path: '/operate/charging',
			// 		name: 'operate_charging',
			// 		component: _import_('operate/charging'),
			// 		meta: {
			// 			title: '计费设置 - 运营设置',
			// 			active: 'operate',
			// 			requireAuth: true
			// 		}
			// 	}, {
			// 		path: '/operate/area',
			// 		name: 'operate_area',
			// 		component: _import_('operate/area'),
			// 		meta: {
			// 			title: '区域设置 - 运营设置',
			// 			active: 'operate',
			// 			requireAuth: true
			// 		}
			// 	}]
			// }
			, {
				path: '/system',
				name: 'system',
				component: _import_('system/index'),
				children: [{
					path: '/system/region',
					name: 'system_region',
					component: _import_('system/region'),
					meta: {
						title: '区域管理 - 系统管理',
						active: 'system',
						requireAuth: true
					}
				},
				{
					path: '/system/config',
					name: 'system_config',
					component: _import_('system/config'),
					meta: {
						title: '系统参数 - 系统管理',
						active: 'system',
						requireAuth: true
					}
				}]
			}
		]
	}]
});

// 导出路由 
// export default new Router({
// 	routes: [{
// 		path: '*',
// 		hidden: true,
// 		meta: {
// 			requireAuth: false
// 		},
// 		redirect: '/error'
// 	}, {
// 		path: '/',
// 		name: 'index',
// 		component: _import_('index'),
// 		meta: {
// 			title: '首页',
// 			requireAuth: false
// 		}
// 	}, {
// 		path: '/login',
// 		name: 'login',
// 		component: _import_('login'),
// 		meta: {
// 			title: '合作商登录',
// 			requireAuth: false
// 		}
// 	}, {
// 		path: '/error',
// 		name: 'error',
// 		component: _import_('error'),
// 		meta: {
// 			title: '请求页面未找到',
// 			requireAuth: false
// 		}
// 	}, {
// 		path: '/platform',
// 		name: 'platform',
// 		component: _import_('platform'),
// 		redirect: '/error',
// 		meta: {
// 			title: '管理中心',
// 			requireAuth: false
// 		},
// 		children: [{
// 				path: '/order',
// 				name: 'order',
// 				component: _import_('order/index'),
// 				meta: {
// 					title: "订单管理",
// 					active: 'order',
// 					requireAuth: true
// 				},
// 				children: [{
// 					path: '/order/list',
// 					name: 'order_list',
// 					component: _import_('order/index'),
// 					meta: {
// 						title: '订单列表',
// 						active: 'order',
// 						requireAuth: true
// 					}
// 				}]
// 			},
// 			{
// 				path: '/console',
// 				name: 'console',
// 				component: _import_('console/index'),
// 				meta: {
// 					title: '控制台',
// 					active: 'console',
// 					requireAuth: true
// 				}
// 			},
// 			{
// 				path: '/console/cost',
// 				name: 'cost',
// 				component: _import_('console/cost'),
// 				meta: {
// 					title: '费用中心',
// 					active: 'console',
// 					requireAuth: true
// 				}
// 			},
// 			// {
// 			// 	path: '/order',
// 			// 	name: 'order',
// 			// 	component: _import_('order/index'),
// 			// 	meta: {
// 			// 		title: "订单管理",
// 			// 		active: 'order',
// 			// 		requireAuth: true
// 			// 	}
// 			// },
// 			{
// 				path: '/driver',
// 				name: 'driver',
// 				component: _import_('driver/index'),
// 				meta: {
// 					title: "司机管理",
// 					active: 'driver',
// 					requireAuth: true
// 				}
// 			},
// 			{
// 				path: '/user',
// 				name: 'user',
// 				component: _import_('user/index'),
// 				meta: {
// 					title: "用户管理",
// 					active: 'user',
// 					requireAuth: true
// 				}
// 			},
// 			{
// 				path: '/total',
// 				name: 'total',
// 				component: _import_('total/index'),
// 				meta: {
// 					title: "数据统计",
// 					active: 'total',
// 					requireAuth: true
// 				}
// 			},
// 			{
// 				path: '/spread',
// 				name: 'spread',
// 				component: _import_('spread/index'),
// 				meta: {
// 					title: "推广管理",
// 					active: 'spread',
// 					requireAuth: true
// 				}
// 			},
// 			{
// 				path: '/operate',
// 				name: 'operate',
// 				component: _import_('operate/index'),
// 				meta: {
// 					title: "运营设置",
// 					active: 'operate',
// 					requireAuth: true
// 				}
// 			},
// 			{
// 				path: '/region',
// 				name: 'region',
// 				component: _import_('region/index'),
// 				meta: {
// 					title: "区域管理",
// 					active: 'region',
// 					requireAuth: true
// 				}
// 			}
// 		]
// 	}]
// });
